import { render, staticRenderFns } from "./NvButton.vue?vue&type=template&id=f48276ec&scoped=true&"
import script from "./NvButton.vue?vue&type=script&lang=js&"
export * from "./NvButton.vue?vue&type=script&lang=js&"
import style0 from "./NvButton.vue?vue&type=style&index=0&id=f48276ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48276ec",
  null
  
)

export default component.exports